"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERCENT_MULTIPLIER = exports.REQUEST_INTERVAL_ADL = exports.REQUEST_INTERVAL_DEFAULT = exports.CACHE_SELECTORS = exports.THIRTY_MINUTES_IN_MS = exports.BN_ONE = exports.BN_ZERO = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.BN_ZERO = new bignumber_js_1.default(0);
exports.BN_ONE = new bignumber_js_1.default(1);
exports.THIRTY_MINUTES_IN_MS = 1000 * 60 * 30;
exports.CACHE_SELECTORS = {
    spotExchange: 'spotExchange',
    usdmExchange: 'usdmExchange',
    coinmExchange: 'coinmExchange',
};
exports.REQUEST_INTERVAL_DEFAULT = 5000;
exports.REQUEST_INTERVAL_ADL = 30000;
exports.PERCENT_MULTIPLIER = 100;
